import { collection, doc, getDocs, updateDoc } from 'firebase/firestore';
import { db } from '../../config';

/**
 * パターンに集約した子パターンの情報を更新する（#2967）。
 *
 * サブコレクションを都度引かずに済ませるために親へ集約している
 * （has_master_mapping と同じ発想）。子パターンの作成・更新・削除のたびに呼ぶ。
 *
 * **2つの値は意味が違うので使い分ける。**
 *
 * | フィールド | 数える対象 | 用途 |
 * |---|---|---|
 * | `has_sub_patterns` | 有効な子パターンのみ | 子パターン判定を実行するか |
 * | `sub_pattern_count` | **無効な子パターンも含む** | 一覧に子パターンが存在するか（展開アイコンの出し分け） |
 *
 * 無効な子パターンも設定画面には表示され編集できるため、件数のほうは除外しない。
 * ここで除外すると「無効な子パターンだけを持つパターン」が一覧から開けなくなり、
 * 有効に戻す手段が無くなる。
 *
 * 更新に失敗してもメイン処理は止めない。ずれた場合に起きるのは
 * 「子パターン判定が余計に走る」か「走らない」だけで、読み取り自体は成立するため。
 * 次回の差分操作時に再評価される。
 */
export const syncHasSubPatterns = async (patternId: string): Promise<void> => {
  if (!patternId) return;
  try {
    const subPatternsRef = collection(db, 'patterns', patternId, 'sub_patterns');
    const snapshot = await getDocs(subPatternsRef);
    // is_active が false の子パターンは判定候補に入らないため、フラグの判定でも数えない。
    // 欠損は有効として扱う（読み込み側の既定と揃える）。
    const hasActive = snapshot.docs.some(d => d.data()?.is_active !== false);
    await updateDoc(doc(db, 'patterns', patternId), {
      has_sub_patterns: hasActive,
      sub_pattern_count: snapshot.size,
    });
  } catch {
    // 更新失敗はメイン処理を止めない（判定の要否と表示を決めるだけの値のため）。
    // 次回の差分操作時に再評価される。
  }
};
